const ABSOLUTE_URL_REGEX = /^(?:[a-z+]+:)?\/\//i

/**
 * Checks if a URL is absolute (starts with protocol or //)
 */
export const isAbsoluteUrl = (url?: string): boolean => {
  if (!url) return false
  return ABSOLUTE_URL_REGEX.test(url)
}

/**
 * Returns the external API URL based on the environment
 *
 * @returns {string} The external API URL
 */
export const getExternalApiUrl = () => {
  // For production, use the configured DMS API URL
  const dmsApiUrl =
    process.env.NEXT_PUBLIC_DMS_API_URL || process.env.DMS_API_URL
  if (dmsApiUrl) {
    return dmsApiUrl
  }

  // If no external API is configured, use the internal API
  // This will be useful during the transition period
  if (typeof window === 'undefined') {
    return `${process.env.NEXT_PUBLIC_BASE_URL || process.env.VERCEL_URL || 'http://localhost:3000'}/api/test`
  }
  return '/api/test'
}

export const getFormattedUrl = (
  endpoint: string,
  params?: { [key: string]: string }
) => {
  const pars = Object.entries(params || {})

  if (pars.length === 0) return endpoint

  pars.forEach(([key, value]) => {
    endpoint = endpoint.replace(`{${key}}`, value)
  })

  return endpoint
}
